import React from 'react';

import { useTheme } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { useThemeMode } from '@packages/fenrir/fenrir-provider';

import {
  RadioButtonListDropdownMenuItem,
  type RadioButtonListDropdownMenuItemOption,
} from '../../radio-button-list-menu-item';

export const ThemeSwitchMenuItem: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme(); // fenrir v1
  const { mode, toggleMode } = useThemeMode(); // fenrir v2

  const options: RadioButtonListDropdownMenuItemOption<'light' | 'dark'>[] = [
    { label: t('appBar:settingsMenu.lightMode'), value: 'light' },
    { label: t('appBar:settingsMenu.darkMode'), value: 'dark' },
  ];

  return (
    <RadioButtonListDropdownMenuItem
      title={t('appBar:settingsMenu.appearance')}
      defaultValue={mode}
      onValueChange={(value) => {
        theme?.setThemeMode(value);
        toggleMode(value);
      }}
      options={options}
    />
  );
};
